/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";

@Component
export default class EntryMixin extends Vue {
  getCompany(id: string, tag: string) {
    const url = API_ENDPOINT + `/companies/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getCompanies(params: any, tag: string) {
    const queryString = this.entryParamsToQueryString(params);
    const url = API_ENDPOINT + `/companies.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getBrands(params: any, tag: string) {
    const queryString = this.entryParamsToQueryString(params);
    const url = API_ENDPOINT + `/brands.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getBrand(id: string, tag: string) {
    const url = API_ENDPOINT + `/brands/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getProducts(params: any, tag: string) {
    const queryString = this.entryParamsToQueryString(params);
    const url = API_ENDPOINT + `/products.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getProduct(id: string, tag: string) {
    const url = API_ENDPOINT + `/products/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  entryParamsToQueryString(params: any): string {
    const queryString: string[] = [];

    for (let key in params) {
      if (typeof params[key] == "object") {
        for (let subkey in params[key]) {
          queryString.push(
            `${key}[${subkey}]=` + encodeURIComponent(params[key][subkey])
          );
        }
      } else {
        queryString.push(`${key}=` + encodeURIComponent(params[key]));
      }
    }

    return queryString.join("&");
  }
}
